import { createSlice } from "@reduxjs/toolkit"

// Part 2
export interface ReportErrorInitialState {
  is500Error: boolean;
  name: string;
  description: string;
  refId: string;
  errorMessage: string;
  isRefIdNull: boolean;
}

const initialState: ReportErrorInitialState = {
  is500Error: false,
  name: '',
  description: '',
  refId: '',
  errorMessage: '',
  isRefIdNull: true
}

// Part 3

export const reportErrorSlice = createSlice({
  name: 'reportError',
  initialState,
  reducers: {
    openModel: (state, action) => {
      state.is500Error = true;
      state.refId = action.payload.refId
    },
    closeModel: (state) => {
      state.is500Error = false;
    },
  }
})

// Part 4
export const { openModel, closeModel } = reportErrorSlice.actions
export default reportErrorSlice.reducer
